import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { shouldRetryQuery } from '../utils/queryRetry';
import { reportClientError } from '../utils/observability';

/**
 * Single QueryClient for the app: smart retries (no 4xx spam), no mutation retries by default.
 * HTTP failures from `api` are reported in `services/api.ts` interceptors (avoids duplicate reports).
 * Query/Mutation caches here only report non-axios failures (e.g. transform bugs).
 */
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (err) => {
      if (!isAxiosError(err)) {
        reportClientError(err, 'query');
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (err) => {
      if (!isAxiosError(err)) {
        reportClientError(err, 'mutation');
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      gcTime: 5 * 60_000,
    },
    mutations: {
      retry: 0,
    },
  },
});
